// Mirrors backend config/constants.js PERMISSIONS / PERMISSION_GROUPS.
// Keep in sync whenever a permission is added, renamed, or regrouped.

export const PERMISSIONS = {
    VIEW_USERS: 'view_users',
    MANAGE_USERS: 'manage_users',
    VIEW_ROLES: 'view_roles',
    MANAGE_ROLES: 'manage_roles',
    EDIT_PROFILE: 'edit_profile',

    VIEW_SHIPMENTS: 'view_shipments',
    MANAGE_SHIPMENTS: 'manage_shipments',
    DELETE_SHIPMENTS: 'delete_shipments',
    UPDATE_SHIPMENT_STATUS: 'update_shipment_status',
    SYNC_TRACKING: 'sync_tracking',

    VIEW_DOCUMENTS: 'view_documents',
    VERIFY_DOCUMENTS: 'verify_documents',
    DELETE_DOCUMENTS: 'delete_documents',

    VIEW_SAILING: 'view_sailing',
    MANAGE_SAILING: 'manage_sailing',
    UPLOAD_BOL: 'upload_bol',

    VIEW_CUSTOMS: 'view_customs',
    MANAGE_CUSTOMS: 'manage_customs',

    VIEW_VEHICLES: 'view_vehicles',
    MANAGE_VEHICLES: 'manage_vehicles',

    VIEW_DELIVERY_RECEIPTS: 'view_delivery_receipts',
    MANAGE_DELIVERY_RECEIPTS: 'manage_delivery_receipts',

    VIEW_UNCLAIMED_PACKAGES: 'view_unclaimed_packages',
    MANAGE_UNCLAIMED_PACKAGES: 'manage_unclaimed_packages',

    VIEW_INVOICES: 'view_invoices',
    MANAGE_INVOICES: 'manage_invoices',
    VIEW_PAYMENTS: 'view_payments',

    VIEW_REPORTS: 'view_reports',

    VIEW_EMAIL_TEMPLATES: 'view_email_templates',
    MANAGE_EMAIL_TEMPLATES: 'manage_email_templates',
    VIEW_EMAIL_LOGS: 'view_email_logs',

    VIEW_NOTIFICATIONS: 'view_notifications',
    MANAGE_NOTIFICATIONS: 'manage_notifications',

    MANAGE_SETTINGS: 'manage_settings',
    MANAGE_SHOPPER_RATES: 'manage_shopper_rates',
    VIEW_STATUS_SETTINGS: 'view_status_settings',
    MANAGE_STATUS_SETTINGS: 'manage_status_settings',
};

export const PERMISSION_LABELS = {
    view_users: 'View users',
    manage_users: 'Manage users',
    view_roles: 'View roles',
    manage_roles: 'Manage roles',
    edit_profile: 'Edit own profile',

    view_shipments: 'View shipments',
    manage_shipments: 'Create & edit shipments',
    delete_shipments: 'Delete shipments',
    update_shipment_status: 'Update shipment status',
    sync_tracking: 'Sync carrier tracking',

    view_documents: 'View documents',
    verify_documents: 'Verify documents',
    delete_documents: 'Delete documents',

    view_sailing: 'View sailing schedules',
    manage_sailing: 'Manage sailing schedules',
    upload_bol: 'Upload Bill of Lading',

    view_customs: 'View customs queue',
    manage_customs: 'Manage customs (mark cleared, generate XML)',

    view_vehicles: 'View vehicle imports',
    manage_vehicles: 'Manage vehicle imports',

    view_delivery_receipts: 'View delivery receipts',
    manage_delivery_receipts: 'Manage delivery receipts',

    view_unclaimed_packages: 'View unclaimed packages',
    manage_unclaimed_packages: 'Manage unclaimed packages',

    view_invoices: 'View invoices',
    manage_invoices: 'Create & edit invoices',
    view_payments: 'View payments',

    view_reports: 'View reports',

    view_email_templates: 'View email templates',
    manage_email_templates: 'Edit email templates',
    view_email_logs: 'View email logs',

    view_notifications: 'View notifications',
    manage_notifications: 'Send notifications',

    manage_settings: 'Manage system settings',
    manage_shopper_rates: 'Manage shopper rates',
    view_status_settings: 'View status settings',
    manage_status_settings: 'Manage status settings (add, edit, reorder statuses)',
};

export const PERMISSION_GROUPS = [
    { label: 'Users & Roles', permissions: ['view_users', 'manage_users', 'view_roles', 'manage_roles'] },
    { label: 'Shipments', permissions: ['view_shipments', 'manage_shipments', 'delete_shipments', 'update_shipment_status', 'sync_tracking'] },
    { label: 'Documents', permissions: ['view_documents', 'verify_documents', 'delete_documents'] },
    { label: 'Sailing & BOL', permissions: ['view_sailing', 'manage_sailing', 'upload_bol'] },
    { label: 'Customs', permissions: ['view_customs', 'manage_customs'] },
    { label: 'Vehicles', permissions: ['view_vehicles', 'manage_vehicles'] },
    { label: 'Delivery Receipts', permissions: ['view_delivery_receipts', 'manage_delivery_receipts'] },
    { label: 'Unclaimed Packages', permissions: ['view_unclaimed_packages', 'manage_unclaimed_packages'] },
    { label: 'Finance', permissions: ['view_invoices', 'manage_invoices', 'view_payments', 'view_reports'] },
    { label: 'Communications', permissions: ['view_email_templates', 'manage_email_templates', 'view_email_logs', 'view_notifications', 'manage_notifications'] },
    { label: 'Settings', permissions: ['manage_settings', 'manage_shopper_rates', 'view_status_settings', 'manage_status_settings'] },
];